'use client'

import * as NavigationMenu from '@radix-ui/react-navigation-menu'

import { useHeaderNavigationItem } from '@/src/domains/header/components/Header/HeaderNavigationItem/HeaderNavigationItem.context'

export interface HeaderNavigationContentProps extends NavigationMenu.NavigationMenuContentProps {}

export const HeaderNavigationContent = (props: HeaderNavigationContentProps) => {
  const { trigger } = useHeaderNavigationItem()

  const contentProps =
    trigger === 'click'
      ? {
          onPointerMove: (event: React.PointerEvent) => event.preventDefault(),
          onPointerLeave: (event: React.PointerEvent) => event.preventDefault(),
          ...props,
        }
      : props

  return <NavigationMenu.Content {...contentProps} />
}
